<template>
  <div class="mint-tube-outside d-flex" :style="{ '--choosenWidth' : choosenWidth + '%'}">
      <div class="gen d-flex justify-content-center align-items-center">
            GEN 0
      </div>
      <div class="gen d-flex justify-content-center align-items-center">
            7K EGGS
      </div>
      <div class="gen d-flex justify-content-center align-items-center">
            14K EGGS
      </div>
      <div class="gen d-flex justify-content-center align-items-center">
            28K EGGS
      </div>
      <div class="gen-last d-flex justify-content-center align-items-center">
            56K EGGS
      </div>
  </div>
</template>

<script>
export default {
    props:{
        choosenWidth:{
            default: 0,
            type: Number
        }
    }
}
</script>

<style scoped>
.mint-tube-outside{
    height: 55px;
    width: 795px;
    border: solid 4px #000;
    position: relative;
    font-size: 29px;
    color: black;
}
.gen{
    position: relative;
    z-index: 1;
    width: 20%;
    border-right: 3px solid black;
}
.gen-last{
    position: relative;
    width: 20%;
}
.mint-tube-outside::after{
    content: "";
    position: absolute;
    background: #39b200;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    top: 0px;
    bottom: 0px;
    left: 0px;
    width: var(--choosenWidth);
}
@media (max-width:769px) {
    .mint-tube-outside{
        width: 280px;
        height: 20px;
        font-size: 11px;
        border: solid 2px #000;
    }
}
</style>